import { Avatar } from 'components/Avatar';
import { UserGraphic } from 'graphics';
import { Box } from 'components/Box';
import { UserProfileResource } from 'util/resources/UserProfile';

type HiredUserProps = {
  userProfile: UserProfileResource;
};

export const HiredUser = (props: HiredUserProps) => {
  const { userProfile } = props;

  const fullName = userProfile.fullName();

  return (
    <Box className="mt-6 flex items-center gap-2.5 !bg-neutral-no-white">
      <Avatar
        name={fullName}
        variant="circle"
        className="flex-none w-8 h-8"
        imageProps={{
          src: userProfile.avatar?.downloadUrl || userProfile.avatar?.smallUrl,
          alt: fullName,
        }}
      >
        <UserGraphic className="flex-none w-full h-full" />
      </Avatar>
      <p className="font-bold text-neutral-ink-blue">{fullName}</p>
    </Box>
  );
};
